// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://epg-uat.gov.sk.ca/api',
  //apiUrl: 'http://localhost:8080/epaymentgateway',
  paysafeEnvironment:'TEST',
  //paysafeTokenUsername:'OT-296970',
  //paysafeTokenPassword:'B-qa2-0-5c7eb284-0-302c02146b234f454e4b7249041cde4155bc722b2db9fa3e021451a03c4302f33f1d5dd135f4af2e8483f1bad290',
  paysafeApiToken: btoa('OT-296970' + ':' + 'B-qa2-0-5c7eb284-0-302c02146b234f454e4b7249041cde4155bc722b2db9fa3e021451a03c4302f33f1d5dd135f4af2e8483f1bad290'),
  redirectWaitSeconds: 4
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
